import { Box, Button, Checkbox, IconButton, Modal } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';

import React, { useEffect, useState } from 'react'
import ConfirmDialog, { esc } from '../../modal/ConfirmDialog';

function ModalComment({lockModal,commentTextArea,changeComment,SetLockModal,changeCourseLockStatus,showSdx}) {
  const [comment,setComment] = useState("")
  // when ticked, the course is pushed to SDX as an update on Continue
  const [sendSdx,setSendSdx] = useState(false)
  const [confirmSdx,setConfirmSdx] = useState(false)

  // only the SDX push needs confirming; a plain lock or unlock goes straight through
  const onContinue = () => {
    if(sendSdx){ setConfirmSdx(true); return; }
    changeCourseLockStatus(false);
  }
    const styleCommentModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "90%",
        maxWidth:"580px",
        minWidth:"360px",
        bgcolor: '#fff',
        border: '1px solid #757575',
        boxShadow: 2,
        borderRadius: 5, 
        p: 4,
      };
      useEffect(()=>{
        setComment("")
        setSendSdx(false)
        setConfirmSdx(false)
      },[lockModal])
  return (
    <Modal open={lockModal?._id} onClose={()=>{
        SetLockModal({});
        commentTextArea.current="";
        }}>
        <Box sx={styleCommentModal}>
        <IconButton sx={{position:"absolute",top:"10px",right:"20px"}} onClick={()=>{
        SetLockModal({});
        setComment("")
        commentTextArea.current="";
        }}>
                <CloseIcon />
              </IconButton>
            <form>
                <label style={{color: '#336fe3'}}>ADD COMMENT :</label>
                <textarea onChange={(e)=>{changeComment(e.target.value.trim());setComment(e.target.value.trim())}} className='w-100 mt-3 mb-3 comment-modal-text'></textarea>

                {showSdx && (
                  <div className='sdx-comment-option'>
                    <Checkbox
                      id="sdx-update"
                      checked={sendSdx}
                      onChange={(e)=>setSendSdx(e.target.checked)}
                      inputProps={{ 'aria-label': 'Update this course in SDX' }}
                      sx={{
                        "&.MuiButtonBase-root":{ color:"gray" },
                        '& .MuiSvgIcon-root': { fontSize: 20, color: 'inherit' },
                        padding: '2px',
                        '&.Mui-checked': { color: '#0178e6 !important' },
                      }}
                    />
                    <label htmlFor="sdx-update">
                      <span className="t">Update this course in SDX</span>
                      <span className="d">
                        Sends the latest course details across to SDX staging.
                      </span>
                    </label>
                  </div>
                )}

                <div className='d-flex justify-content-end gap-3 modal-actions'>
                 {/* <Button disabled={comment?.length=== 0} variant="contained" color="primary" onClick={changeCourseLockStatus}>Submit</Button> */}
                 <Button variant="contained" color="secondary" onClick={onContinue}>Continue</Button>
                </div>
            </form>

            <ConfirmDialog
              open={confirmSdx}
              tone="warn"
              title="Send this course to SDX?"
              html={`The latest details for <b>${esc(lockModal?.configname)}</b> will be sent across to SDX staging, replacing what is there now.`}
              confirmText="Yes, send"
              cancelText="Go back"
              onConfirm={()=>{ setConfirmSdx(false); changeCourseLockStatus(true); }}
              onCancel={()=>setConfirmSdx(false)}
            />
        </Box>
    </Modal>
  )
}

export default ModalComment